/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:e279e545-1dfd-4588-a287-e8ae42b4e2a7",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_zUfUtp2hr",
    "aws_user_pools_web_client_id": "4bkcsj9m9g2sl883hsqkfv2v57",
    "oauth": {}
};


export default awsmobile;
